
// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';

// libraries

// Afidium
import { MultiCheckboxComponent } from './multi-checkbox.component';
import { FormFieldModule } from 'libraries/module/formbuilder/fields/form-field/form-field.module';
import { MultiCheckboxFieldComponent } from './multi-checkbox-field.component';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from "@angular/material/radio";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        FormFieldModule,
        ReactiveFormsModule,
        //TODO NG UPGRADE NgxErrorsModule,
        MatCheckboxModule,
        MatRadioModule,
        BtnModule,
        MatTooltipModule,
    ],
    exports: [
        MultiCheckboxComponent,
    ],
    declarations: [
        MultiCheckboxComponent,
        MultiCheckboxFieldComponent,
    ],
    providers: [],
})
export class MultiCheckBoxModule { }
